// Angular + external
import { Component, ElementRef, OnDestroy } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";
import { BfxBlotterFilterService } from "../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxBlotterDeleteFilterActionEvent } from "../bfx-blotter-filter/models/bfx-blotter-filter-delete-event";
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
import { BfxDialogData } from "./models/bfx-dialog-data.model";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: "bfx-dialog-filter-delete",
  templateUrl: "./html/bfx-dialog-filter-delete.html",
  standalone: false,
})
export class BfxDialogFilterDeleteComponent extends BfxDialogBaseComponent implements OnDestroy {
  public deleteMessage: string = "";
  private deleteFilterCallback: any;

  /***************************************/
  /* DATA */
  public config: any = {
    debug: true,
  };

  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 360,
      height: 160,
      title_text: "Confirm",
      message: "",
    },
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private _translationService: TranslateService,
    private _filterService: BfxBlotterFilterService,
    private _element: ElementRef,
  ) {
    super();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public openDialog(dialogData: BfxDialogData): Observable<any> {
    this.data.dialogId = dialogData.dialogId;
    let event: BfxBlotterDeleteFilterActionEvent = dialogData.event;
    this.data.actionEvent = event;
    this.deleteFilterCallback = this.data.actionEvent._callback;
    this.data.dialogData.message = this._translationService.instant("confirm.delete.filter");

    this.data.dialogData.show = true;
    this._filterService.setIsEditableMode(true);
    this._filterService.setIsDialogMode(true);

    NativeDesktopSupport.prepareEmbeddedDialog(dialogData.body, this._dialog, this._element);
    this.data.dialogData.show = true;

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    super.closeDialog();

    this._filterService.setIsEditableMode(false);
    this._filterService.setIsDialogMode(false);
    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  /* COPY FILTER INTO- Actions */
  public actionDeleteFilter_confirm(): void {
    this.deleteFilterCallback();
    this.closeDialog();
  }

  public actionDeleteFilter_close(): void {
    this.closeDialog();
  }
}
